module.exports = __webpack_public_path__ + "media/ideation-05-bg-brandvideo-video.699c7ac3.mp4";